import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const testimonials = [
  {
    quote: "Seas came out same day when our AC died in the middle of summer. He diagnosed the problem quickly, gave us a fair price, and had us cool again before dinner. Couldn't ask for better service.",
    author: "Maria R.",
    location: "Las Vegas, NV",
  },
  {
    quote: "Honest, professional, and knows his stuff. He didn't try to sell us a new unit when we just needed a repair. That's rare in this business. Highly recommend Seas Heating and AC.",
    author: "James T.",
    location: "Henderson, NV",
  },
  {
    quote: "We've used Seas for years—furnace tune-ups, AC maintenance, you name it. He treats our home like his own. Always on time, always fair pricing. A true local gem.",
    author: "Patricia & Mike L.",
    location: "Las Vegas, NV",
  },
  {
    quote: "Called at 8pm with a heating emergency. Seas answered, came out that night, and got our furnace running. He could have charged us anything—he charged what was fair. That says a lot.",
    author: "David K.",
    location: "North Las Vegas, NV",
  },
  {
    quote: "Finally, an HVAC company that doesn't talk down to you or oversell. Seas explained everything clearly and gave us options. We went with his recommendation and couldn't be happier.",
    author: "Sandra M.",
    location: "Las Vegas, NV",
  },
  {
    quote: "My mom's AC was out and she's elderly. Seas showed up fast, was patient with her questions, and fixed it the same day. He even checked the filter and gave her tips. Top-notch service.",
    author: "Carlos G.",
    location: "Summerlin, NV",
  },
];

export default function Testimonials() {
  useEffect(() => {
    document.title = 'Testimonials | Seas Heating and AC';
  }, []);

  return (
    <>
      {/* Page Header */}
      <section className="bg-seas-blue text-white py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-white/80 text-sm font-semibold uppercase tracking-widest mb-2">Reviews</p>
          <h1 className="text-3xl lg:text-4xl font-bold mb-4 tracking-tight">Testimonials & Reviews</h1>
          <p className="text-gray-300 max-w-2xl">
            What our customers say about Seas Heating and AC. Real reviews from real people in our community.
          </p>
        </div>
      </section>

      {/* Intro + image section */}
      <section className="py-14 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div>
              <p className="text-seas-blue/80 text-sm font-semibold uppercase tracking-widest mb-2">Customer Voices</p>
              <h2 className="text-2xl font-bold text-seas-gray mb-4 tracking-tight">Real Customers, Real Experiences</h2>
              <p className="text-gray-600 leading-relaxed">
                We're proud of the relationships we've built across the Las Vegas valley. Our customers know they can 
                count on honest work, fair pricing, and a technician who shows up and gets the job done. Read what 
                your neighbors have to say about Seas Heating and AC.
              </p>
            </div>
            <img src="/images/testimonials-image1.png" alt="Customer experiences - Seas Heating and AC" className="min-h-[260px] w-full object-cover rounded-xl" />
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-16 lg:py-24 bg-gray-50/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.author}
                className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all"
              >
                <p className="text-gray-600 mb-6 italic leading-relaxed">"{testimonial.quote}"</p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="font-semibold text-seas-gray">{testimonial.author}</p>
                  <p className="text-sm text-gray-500">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-4">Have a great experience with Seas? We'd love to hear from you.</p>
            <Link
              to="/contact"
              className="inline-block bg-seas-gold text-white font-semibold px-8 py-3 rounded-lg hover:bg-amber-600 transition-colors"
            >
              Get in Touch
            </Link>
          </div>

          {/* Trust / image section */}
          <section className="mt-20 pt-16 border-t border-gray-200">
            <p className="text-seas-blue/80 text-sm font-semibold uppercase tracking-widest text-center mb-2">Trust</p>
            <h2 className="text-2xl font-bold text-seas-gray text-center mb-8 tracking-tight">Trusted Across Las Vegas</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="h-[240px] overflow-hidden rounded-xl">
                <img src="/images/testimonials-image2.png" alt="Trusted HVAC in Las Vegas - Seas Heating and AC" className="w-full h-full object-cover" />
              </div>
              <div className="h-[240px] overflow-hidden rounded-xl">
                <img src="/images/testimonials-image3.png" alt="Customer satisfaction - Seas Heating and AC" className="w-full h-full object-cover" />
              </div>
            </div>
            <p className="text-gray-600 text-center mt-6 max-w-2xl mx-auto">
              From residential homes to small businesses, we've earned our reputation one job at a time. 
              Your satisfaction and your comfort are what matter most.
            </p>
          </section>
        </div>
      </section>
    </>
  );
}
